// ExportToConfirmitModal.tsx
import React from "react"
import { Modal, Typography } from "antd"
import ExportToConfirmitOptionsForm from "./ExportToConfirmitOptionsForm.component"
import { Project } from "stores/projectStore"
import { Variant } from "types/questionnaire.types"

/**
 * Props interface for the ExportToConfirmitModal component
 */
interface ExportToConfirmitModalProps {
  /** The project data that will be exported */
  project: Project
  /** Determines if the modal is visible */
  isExportConfirmitModalVisible: boolean
  /** Function to toggle the visibility of the modal */
  setExportConfirmitModalVisible: (visible: boolean) => void
  /** The variants data that will be passed to the export form */
  variants: Variant[]
}

/**
 * ExportToConfirmitModal component renders a modal for exporting a project to
 * Confirmit (Forsta Plus) XML format.
 *
 * @component
 * @param props - The component props
 * @returns The rendered ExportToConfirmitModal component
 */
const ExportToConfirmitModal: React.FC<ExportToConfirmitModalProps> = ({
  project,
  isExportConfirmitModalVisible,
  setExportConfirmitModalVisible,
  variants,
}) => {
  const { Title } = Typography

  return (
    <Modal
      open={isExportConfirmitModalVisible}
      centered={true}
      footer={false}
      closable={false}
      destroyOnHidden={true}
    >
      <Title style={{ margin: 0, marginBottom: "0.5em" }} level={5}>
        Export To Confirmit XML
      </Title>
      <ExportToConfirmitOptionsForm
        project={project}
        variants={variants}
        setExportConfirmitModalVisible={setExportConfirmitModalVisible}
      />
    </Modal>
  )
}

export default ExportToConfirmitModal
